import React from 'react';
import { useTranslation } from 'react-i18next';

export function BorderConfig({ obj, handleBorder, paddingTopZero }) {
  const { t } = useTranslation('common');
  return (
    <div className={`${paddingTopZero ? 'pt-0' : 'py-3'} pl-0 pr-2`}>
      <p className="mb-2 f-14 text-bold">{t('CUSTOM_MODULE.BORDER')}</p>
      <div className="checkbox-label">
        <input type="checkbox" id="border" onChange={handleBorder} checked={obj?.otherConfiguration?.border === true} name="border" />
        <label htmlFor="border" className="chklabel">
          <span>{t('CUSTOM_MODULE.OUTLINE_BORDER')}</span>
        </label>
      </div>
    </div>
  );
}

export default BorderConfig;
